import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
export function Testimonios() {
  const testimonios = [{
    text: 'Llevaba tres años con omeprazol todos los días. Después de aplicar el protocolo, en menos de una semana empecé a entender por qué me daba el reflujo. Fue la primera vez que sentí que tenía control sobre lo que me pasaba.',
    initial: 'MC',
    color: 'bg-verde',
    name: 'María C.',
    info: '52 años — Buenos Aires'
  }, {
    text: 'Me despertaba casi todas las noches. Probé de todo: pastillas, dietas, nada me daba un resultado duradero. El protocolo me enseñó que el problema era el horario de mi cena y dos alimentos específicos que nunca hubiese sospechado.',
    initial: 'RG',
    color: 'bg-[#3d6b9e]',
    name: 'Roberto G.',
    info: '61 años — Córdoba'
  }, {
    text: 'Tenía miedo de comer en reuniones, cumpleaños, cenas. Eso cambia cuando entendés qué te afecta específicamente. El diario de síntomas del bono fue lo que más me ayudó a identificarlo rápido.',
    initial: 'LP',
    color: 'bg-[#7d4e9e]',
    name: 'Laura P.',
    info: '45 años — Rosario'
  }];
  return <section id="prueba-social" className="bg-blanco py-[100px]" data-id="element-257">
      <div className="container-custom" data-id="element-258">
        <SectionHeader eyebrow="Personas reales" title={<>
              Lo que dice quien ya
              <br data-id="element-260" />
              aplicó el protocolo
            </>} theme="light" data-id="element-259" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-[60px]" data-id="element-261">
          {testimonios.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-crema rounded-[8px] p-7 border-l-[3px] border-verde-claro relative" data-id="element-262">
              <span className="font-display text-[64px] text-verde-claro opacity-30 leading-[0.5] mb-4 block" data-id="element-263">
                "
              </span>
              <p className="text-[16px] text-gris-oscuro leading-[1.8] mb-5 italic" data-id="element-264">
                {t.text}
              </p>

              <div className="flex items-center gap-3" data-id="element-265">
                <div className={`w-11 h-11 rounded-full ${t.color} flex items-center justify-center text-white font-bold text-[16px] shrink-0`} data-id="element-266">
                  {t.initial}
                </div>
                <div data-id="element-267">
                  <div className="text-dorado text-[15px] mb-1" data-id="element-268">★★★★★</div>
                  <div className="font-semibold text-[15px] text-negro" data-id="element-269">
                    {t.name}
                  </div>
                  <div className="text-[14px] md:text-[13px] text-gris" data-id="element-270">
                    {t.info}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}